import type { Dictionary } from '../i18n/dictionary';
import { toast } from '../lib/toast';
import type { Story } from '../lib/story';
import { IconArrowsRightLeft } from './icons';
import { Menu } from './Menu';

const sample: Dictionary<{
  list: string;
  trigger: string;
  picked: (label: string) => string;
  meals: string[];
}> = {
  pl: {
    list: 'Przenieś do',
    trigger: 'Przenieś wpis',
    picked: (label) => `Wybrano: ${label}`,
    meals: ['Śniadanie', 'Obiad', 'Kolacja', 'Przekąski'],
  },
  en: {
    list: 'Move to',
    trigger: 'Move entry',
    picked: (label) => `Picked: ${label}`,
    meals: ['Breakfast', 'Lunch', 'Dinner', 'Snacks'],
  },
};

export default {
  kind: 'component',
  title: { pl: 'Menu', en: 'Menu' },
  description: {
    pl: 'Przycisk z ikoną, który rozwija listę akcji. Po otwarciu fokus wchodzi do listy; strzałki po niej chodzą, Escape zamyka i wraca na przycisk, a wybór albo kliknięcie obok też zamyka. Lista otwiera się w lewo od prawej krawędzi przycisku, więc menu stoi na końcu wiersza. Tu wybór pokazuje toast.',
    en: 'An icon button that drops a list of actions below it. Focus moves into the list on open; arrows walk it, Escape closes it back onto the button, and a pick or a press outside closes it too. The list opens leftwards from the right edge of the button, so a menu sits at the end of a row. Here a pick shows a toast.',
  },
  variants: [
    {
      name: { pl: 'Akcje', en: 'Actions' },
      render: (locale) => {
        const t = sample[locale];
        return (
          <div className="form-actions">
            <Menu
              label={t.list}
              triggerLabel={t.trigger}
              title={t.trigger}
              icon={<IconArrowsRightLeft />}
              items={t.meals.map((meal) => ({
                key: meal,
                label: meal,
                onSelect: () => toast.success(t.picked(meal)),
              }))}
            />
          </div>
        );
      },
    },
  ],
} satisfies Story;
